import React from 'react';
import { Loader2, Pencil, Plus, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

export const CenterFaqsSection = ({
  faqs = [],
  status,
  error,
  draft,
  editingIndex,
  onDraftChange,
  onSaveDraft,
  onDelete,
  onEdit,
  onCancelEdit,
  onRetry,
  onSaveFaqs,
  saving,
  saveError,
  saveSuccess,
}) => (
  <div className="space-y-3 pt-2 border-t border-zinc-800" data-testid="center-faqs">
    <Label>Preguntas frecuentes (FAQ)</Label>
    {status === 'LOADING' && (
      <div className="flex items-center gap-2 text-sm text-zinc-500">
        <Loader2 className="w-4 h-4 animate-spin" /> Cargando preguntas frecuentes...
      </div>
    )}
    {status === 'ERROR+RETRY' && (
      <div className="flex items-center justify-between gap-3 text-sm text-red-400">
        <span>{error}</span>
        <Button size="sm" variant="outline" onClick={onRetry}>Reintentar</Button>
      </div>
    )}
    {(status === 'SUCCESS_EMPTY' || status === 'SUCCESS_NONEMPTY') && (
      <>
        {status === 'SUCCESS_EMPTY' && <p className="text-sm text-zinc-500">No hay preguntas frecuentes configuradas.</p>}
        {faqs.map((item, idx) => (
          <div key={idx} className="border border-zinc-700 rounded-sm p-3 space-y-1">
            {editingIndex === idx ? (
              <div className="space-y-2">
                <Input value={draft.question} onChange={e => onDraftChange({ ...draft, question: e.target.value })} placeholder="Pregunta" className="input-tactical text-sm" />
                <Textarea rows={2} value={draft.answer} onChange={e => onDraftChange({ ...draft, answer: e.target.value })} placeholder="Respuesta" className="input-tactical text-sm resize-none" />
                <div className="flex gap-2"><Button size="sm" className="btn-primary text-xs" onClick={onSaveDraft}>Guardar</Button><Button size="sm" variant="ghost" className="text-xs" onClick={onCancelEdit}>Cancelar</Button></div>
              </div>
            ) : (
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0"><p className="text-sm font-medium text-zinc-200">{item.question}</p><p className="text-xs text-zinc-400 mt-0.5">{item.answer}</p></div>
                <div className="flex gap-1 flex-shrink-0"><Button aria-label="Editar FAQ" size="icon" variant="ghost" className="h-6 w-6" onClick={() => onEdit(idx)}><Pencil className="w-3 h-3" /></Button><Button aria-label="Eliminar FAQ" size="icon" variant="ghost" className="h-6 w-6 text-zinc-400 hover:text-red-400" onClick={() => onDelete(idx)}><Trash2 className="w-3 h-3" /></Button></div>
              </div>
            )}
          </div>
        ))}
        {editingIndex === null && (
          <div className="border border-dashed border-zinc-700 rounded-sm p-3 space-y-2">
            <Input value={draft.question} onChange={e => onDraftChange({ ...draft, question: e.target.value })} placeholder="Nueva pregunta..." className="input-tactical text-sm" />
            <Textarea rows={2} value={draft.answer} onChange={e => onDraftChange({ ...draft, answer: e.target.value })} placeholder="Respuesta..." className="input-tactical text-sm resize-none" />
            <Button size="sm" variant="outline" className="text-xs" onClick={onSaveDraft} disabled={!draft.question.trim() || !draft.answer.trim()}><Plus className="w-3 h-3 mr-1" />Añadir pregunta</Button>
          </div>
        )}
      </>
    )}
    {status !== 'LOADING' && status !== 'ERROR+RETRY' && (
      <div className="flex items-center justify-end gap-3 pt-2 border-t border-zinc-800">
        {saveError && <span className="text-sm text-red-400">{saveError}</span>}
        {saveSuccess && <span className="text-sm text-green-400">Preguntas frecuentes guardadas</span>}
        <Button className="btn-primary" onClick={onSaveFaqs} disabled={saving}>
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Guardar preguntas frecuentes'}
        </Button>
      </div>
    )}
  </div>
);
